import { InputAdornment, TextField } from '@mui/material';

/** A small number box with an optional sign before it ("≥") and a unit after it ("%", "days") */
export function NumberInput(props: {
  value: string;
  onChange: (v: string) => void;
  label: string;
  before?: string;
  after: string;
}) {
  return (
    <TextField
      size="small"
      value={props.value}
      onChange={(e) => props.onChange(e.target.value)}
      sx={{ width: 150 }}
      slotProps={{
        htmlInput: { inputMode: 'decimal', 'aria-label': props.label },
        input: {
          startAdornment: props.before ? <InputAdornment position="start">{props.before}</InputAdornment> : undefined,
          endAdornment: <InputAdornment position="end">{props.after}</InputAdornment>,
        },
      }}
    />
  );
}
